// extracted by mini-css-extract-plugin
export default {"RsTag":"tag_RsTag__rDZ-3","RsBindingTag":"tag_RsBindingTag__0cHDL"};